import { render, staticRenderFns } from "./VirtualScroller.vue?vue&type=template&id=0bce8e58&scoped=true&"
import script from "./VirtualScroller.vue?vue&type=script&lang=js&"
export * from "./VirtualScroller.vue?vue&type=script&lang=js&"
import style0 from "./VirtualScroller.vue?vue&type=style&index=0&id=0bce8e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce8e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bce8e58')) {
      api.createRecord('0bce8e58', component.options)
    } else {
      api.reload('0bce8e58', component.options)
    }
    module.hot.accept("./VirtualScroller.vue?vue&type=template&id=0bce8e58&scoped=true&", function () {
      api.rerender('0bce8e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/crash/components/crash-bet/VirtualScroller.vue"
export default component.exports